import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import LoggedInRoute from '../routes/loggedInRoute';
import Reports from '../views/reports';
import Header from "components/Header/Header";
import HeaderOptions from 'components/Header/HeaderOptions';
import Footer from "components/Footer.jsx";
import ReactGA from 'react-ga';

class App extends Component {
  checkOutsider = () => {
    if(localStorage.getItem('accessToken')){
      return false
    }
    return true;
  }

  logout = () => {
    localStorage.clear();
    const {history} = this.props;
    history.push('/');
  }
  
  render() {
    ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash)
    if(this.checkOutsider()){
      return (<Redirect to='/login' />)
    }
    return (
      <div>
      <Header headerOption={<HeaderOptions logoutMethod={this.logout}/>}/>    
      <section className="content-section">
      <Switch>
        { LoggedInRoute.map((prop, key) => {
            if(prop.redirect){
              return (
                <Redirect from={prop.path} to={prop.pathTo} key={key} />
              )
            }
            return (
              <Route path={prop.path} component={prop.component} key={key}/>
            )
        })}
      </Switch>
      </section>
      <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx